/** @format */

import React from 'react';
import {SHAPE_CARTON_CUSTOM, SHAPE_CUSTOM} from 'frontier-constants';

export default function SVGDownload({width, length, depth, shapeId, isSquareCorners, errors}) {
    const cartonSizeError = errors.find(e => e.category === 'carton_size');
    const isCustomShape =
        parseInt(shapeId) === SHAPE_CUSTOM || parseInt(shapeId) === SHAPE_CARTON_CUSTOM;
    if (width && length && shapeId && !isCustomShape && !cartonSizeError) {
        const options = {
            width,
            length,
            depth,
            shape_id: shapeId,
            is_square_corners: isSquareCorners,
            visibleLayers: ['dieline', 'bleedline', 'kisscutline', 'creaseline']
        };

        return (
            <div className="mt-2">
                <span className="arrow-indicator--closed">
                    <a
                        download={`sttark_shape_file_${width}x${length}${depth ? 'x' + depth : ''}${
                            isSquareCorners ? 's' : ''
                        }.svg`}
                        href={`/api/sizes/get-shape-svg?${new URLSearchParams(options)}`}
                        target="_blank"
                        className={'svg-download-link'}>
                        Download Template for Selected Size
                    </a>
                </span>
            </div>
        );
    }

    return null;
}
